import React from 'react';
import PropTypes from 'prop-types';
import { ALERT_SUCCESS } from '@client/redux/modules/successOverlay/constants';
import { CheckIcon, ErrorIcon } from '@client/components/shared/SvgIcons';
import CSSModules from 'react-css-modules';
import styles from './doiSuccessAlert.scss';

export function DoiSuccessAlert({ type, message }) {
    const Icon = type === ALERT_SUCCESS ? CheckIcon : ErrorIcon;

    return (
        <p styleName="alert">
            <Icon styleName="icon" /> {message}
        </p>
    );
}

DoiSuccessAlert.propTypes = {
    type: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
};

export default CSSModules(DoiSuccessAlert, styles);
